import React, { useState, useContext, useEffect } from 'react';
import { Web3Provider, Web3Context } from './context/Web3Context';
import useNotification from './hooks/useNotification';
import Loader from './components/Loader/Loader';
import NotificationContainer from './components/Notification/Notification';
import ConnectWallet from './components/ConnectWallet/ConnectWallet';
import RegistrationGate from './components/RegistrationGate/RegistrationGate';
import Header from './components/Header/Header';
import Navbar from './components/Navbar/Navbar';
import Dashboard from './components/Dashboard/Dashboard';
import Packages from './components/Packages/Packages';
import Income from './components/Income/Income';
import Team from './components/Team/Team';
import Admin from './components/Admin/Admin';
import './App.css';

function AppContent() {
  const { account, userId, isAdmin, isConnecting } = useContext(Web3Context);
  const notify = useNotification();
  const [activePage, setActivePage] = useState('dashboard');
  const [appLoading, setAppLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setAppLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  if (appLoading) return <Loader message="Initializing Platform..." />;
  if (isConnecting) return <Loader message="Connecting Wallet..." />;

  function navigate(page) {
    setActivePage(page);
    window.scrollTo(0, 0);
  }

  function renderPage() {
    switch (activePage) {
      case 'dashboard': return <Dashboard onNavigate={navigate} notify={notify} />;
      case 'packages': return <Packages notify={notify} />;
      case 'income': return <Income notify={notify} />;
      case 'team': return <Team notify={notify} />;
      case 'admin': return isAdmin ? <Admin notify={notify} /> : <Dashboard onNavigate={navigate} notify={notify} />;
      default: return <Dashboard onNavigate={navigate} notify={notify} />;
    }
  }

  return (
    <div className="app">
      <NotificationContainer notifications={notify.notifications} onRemove={notify.removeNotification} />
      {!account ? (
        <ConnectWallet />
      ) : !userId ? (
        <>
          <Header />
          <div className="app-aurora-bg" />
          <main className="app-main app-page-enter">
            <RegistrationGate notify={notify} />
          </main>
        </>
      ) : (
        <>
          <Header />
          <div className="app-aurora-bg" />
          <main className="app-main app-page-enter" key={activePage}>
            {renderPage()}
          </main>
          <Navbar activePage={activePage} onNavigate={navigate} isAdmin={isAdmin} />
        </>
      )}
    </div>
  );
}

export default function App() {
  return (
    <Web3Provider>
      <AppContent />
    </Web3Provider>
  );
}
